<template>
  <div
    class="dots-progress"
    role="progressbar"
    :aria-valuenow="currentIndex + 1"
    :aria-valuemin="1"
    :aria-valuemax="total"
  >
    <span
      v-for="n in total"
      :key="n"
      class="dots-progress__dot"
      :class="{
        'dots-progress__dot--done': n - 1 < currentIndex,
        'dots-progress__dot--active': n - 1 === currentIndex,
      }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DotsProgress',

  props: {
    total: { type: Number, required: true },
    currentIndex: { type: Number, required: true },
  },
});
</script>

<style lang="scss" scoped>
.dots-progress {
  display: flex;
  gap: 6px;
  margin-top: 0.25rem;

  &__dot {
    width: 24px;
    height: 3px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.12);
    transition: background-color 0.35s ease, width 0.35s ease;

    &--done {
      background: #94c840;
    }

    &--active {
      background: #94c840;
      width: 32px;
    }
  }
}
</style>
